import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { API_URL, token } from "./config";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();
  // State for password inputs
  const [file, setFile] = useState();
  const [hidePin, setHidePin] = useState(true);
  const [hideNewPin, setHideNewPin] = useState(true);
  const [hideConfirmNewPin, setHideConfirmNewPin] = useState(true);

  const [inputs, setInputs] = useState({
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  function handleChange(e) {
    console.log(e.target.files);
    setFile(e.target.files[0]);
  }

  // State for next of kin and marital status
  const [nok, setNok] = useState({
    address: "",
    name: "",
    phone: "",
    relationship: "",
    marital: "",
    spouseName: "",
    spousePhone: "",
    dob: ""
  });

  // State for preferred communication
  const [isMailSelected, setIsMailSelected] = useState(false);
  const [isPhoneSelected, setIsPhoneSelected] = useState(false);

  // State for profile image
  const [profileImage, setProfileImage] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);

  // State for loading indicators
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [isLoadingCommunication, setIsLoadingCommunication] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = (field) => {
    if (field === "old") setHidePin(!hidePin);
    if (field === "new") setHideNewPin(!hideNewPin);
    if (field === "confirm") setHideConfirmNewPin(!hideConfirmNewPin);
  };

  // Handle password change
  const handlePasswordChange = async () => {
    if (
      !inputs.email ||
      !inputs.oldPassword ||
      !inputs.newPassword ||
      !inputs.confirmNewPassword
    ) {
      Swal.fire({
        text: "Submission Error. Fill all the fields before proceeding",
        icon: "error",
      });
      return;
    }
    if (inputs.newPassword !== inputs.confirmNewPassword) {
      Swal.fire({
        text: "Submission Error. Password confirmation is wrong",
        icon: "error",
      });
      return;
    }

    const obj = {
      email: inputs.email,
      oldPassword: inputs.oldPassword,
      newPassword: inputs.newPassword,
    };

    setIsLoadingPassword(true);
    let signinresponse = await fetch(`${API_URL}/onboarding/resetpassword`, {
      method: "post",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
      },
    });

    let resJson = await signinresponse.json();

    console.log(resJson);

    if (resJson.message == "Invalid email or password") {
      Swal.fire({
        text: "Submission Error. The sent email or password is invalid",
        icon: "error",
      });
      setIsLoadingPassword(false);
      return;
    }

    if (resJson.message == "Password reset successfully") {
      setInputs({
        email: "",
        oldPassword: "",
        newPassword: "",
        cnnewPassword: "",
        confirmNewPassword: ""
      });
      setIsLoadingPassword(false);
      Swal.fire({
        text: "Password reset successfully",
        icon: "success",
      });
    }
  };

  // Handle preferred communication update
  const handleCommunicationUpdate = async () => {
    const userId = localStorage.getItem("UserID");
    setIsLoadingCommunication(true);

    let signinresponse = await fetch(
      `${API_URL}/members/preferred/comm/${userId}`,
      {
        method: "put",
        body: JSON.stringify({
          email: isMailSelected,
          phone: isPhoneSelected,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    let resJson = await signinresponse.json();

    console.log(resJson);
    setIsLoadingCommunication(false);

    if (resJson.message == "Member details updated successfully") {
      Swal.fire({
        text: "Member details updated successfully",
        icon: "success",
      });
    } else {
      Swal.fire({
        text: "Member details did not update successfully. Contact sysem admin",
        icon: "error",
      });
    }
  };

  // Handle next of kin and marital status update
  const handleDetailsUpdate = async () => {
    const userId = localStorage.getItem("UserID");
    setIsLoadingDetails(true);

    let signinresponse = await fetch(`${API_URL}/members/details/${userId}`, {
      method: "put",
      body: JSON.stringify({
        address: nok.address,
        city: "Harare",
        nxt_of_kin: nok.name,
        nok_relationship: nok.relationship,
        nok_phone: nok.phone,
        sponame: nok.spouseName,
        marital_status: nok.marital,
        spophone: nok.spousePhone,
        dob: nok.dob || "",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    let resJson = await signinresponse.json();

    console.log(resJson);
    setIsLoadingDetails(false);

    if (resJson.message == "Member details updated successfully") {
      localStorage.setItem("UserAddress", nok.address);
      localStorage.setItem("UserNok", nok.name);
      localStorage.setItem("UserNokPhone", nok.phone);
      localStorage.setItem("UserNokRel", nok.relationship);
      localStorage.setItem("UserMarital", nok.marital);
      localStorage.setItem("UserSpouse", nok.spouseName);
      localStorage.setItem("UserSpousePhone", nok.spousePhone);
      Swal.fire({
        text: "Member details updated successfully",
        icon: "success",
      });
      // setNok({
      //   address: "",
      //   name: "",
      //   phone: "",
      //   relationship: "",
      //   marital: "",
      //   spouseName: "",
      //   spousePhone: "",
      // });
      fetchMemberData();
    } else {
      Swal.fire({
        text: "Member details did not update successfully. Contact sysem admin",
        icon: "error",
      });
    }
  };

  // Handle profile image upload
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsImageUploading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
        setIsImageUploading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImgUpload = async () => {
    if (file == "") {
      Swal.fire({
        text: "Submission Error. Select the image first before proceeding",
        icon: "error",
      });
      return;
    }

    const UserID = localStorage.getItem("UserID");
    setIsImageUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    await axios
      .post(`${API_URL}/upload/${UserID}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      .then((response) => {
        console.log("Pik" + response.data.Filename);

        if (response.data.result.message == "Member updated successfully") {
          const setnewimg = async () => {
            localStorage.setItem("UserImg", response.data.Filename);
          };
          setnewimg();
          setFile("");
          setIsImageUploading(false);
          localStorage.setItem("UserImg", response.data.Filename);
          Swal.fire({
            text: "Successfull. Image uploaded successfully",
            icon: "success",
          });
          return;
        }
      })
      .catch((error) => {
        setIsImageUploading(false);
        console.log(error.response.data.message);
      });
  };

  const fetchMemberData = async () => {
    try {

      const id = await localStorage.getItem("UserID");

      const response = await fetch(`${API_URL}/members/${id}`, {
        headers: {
          'Authorization': `Bearer ${token()}`
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log(data[0])

      setNok(prev => ({
        ...prev,
        address: data[0].Address,
        name: data[0].nxt_of_kin,
        phone: data[0].nok_phone,
        relationship: data[0].nok_relationship,
        marital: data[0].marital_status,
        spouseName: data[0].sponame,
        spousePhone: data[0].spophone,
        dob: data[0].DOB || "",
      }));

      setIsMailSelected(data[0].preferred_email);
      setIsPhoneSelected(data[0].preferred_phone);

      // Assuming the API returns an array, get the first element
      // setFormData(data[0]);
    } catch (error) {
      console.error('Error fetching member data:', error);
      // setConnResult('error');
    }
  };
  useEffect(() => {

    fetchMemberData();
  }, []);


  const WhatsAppStyleDatePicker = ({ value, onChange }) => {
    // Initialize with empty values or parsed from the prop
    const [dateParts, setDateParts] = useState({
      day: '',
      month: '',
      year: ''
    });

    // Initialize only once when component mounts
    useEffect(() => {
      if (value) {
        try {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            setDateParts({
              day: date.getDate().toString(),
              month: (date.getMonth() + 1).toString(),
              year: date.getFullYear().toString()
            });
          }
        } catch (e) {
          console.error("Error parsing date:", e);
        }
      }
    }, []); // Empty dependency array means this runs only once on mount

    const handleChange = (part, value) => {
      const newDateParts = {
        ...dateParts,
        [part]: value
      };

      setDateParts(newDateParts);

      // Only call onChange when we have all three parts
      if (newDateParts.day && newDateParts.month && newDateParts.year) {
        const formattedDate = `${newDateParts.year}-${newDateParts.month.padStart(2, '0')}-${newDateParts.day.padStart(2, '0')}`;
        onChange(formattedDate);
      }
    };
    // Generate options for days (1-31)
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    // Generate options for months
    const months = [
      { value: 1, name: 'January' },
      { value: 2, name: 'February' },
      { value: 3, name: 'March' },
      { value: 4, name: 'April' },
      { value: 5, name: 'May' },
      { value: 6, name: 'June' },
      { value: 7, name: 'July' },
      { value: 8, name: 'August' },
      { value: 9, name: 'September' },
      { value: 10, name: 'October' },
      { value: 11, name: 'November' },
      { value: 12, name: 'December' }
    ];
    // Generate options for years (1900-current year)
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => currentYear - i)

    return (
      <div style={styles.datePickerContainer}>
        <select
          value={dateParts.day}
          onChange={(e) => handleChange('day', e.target.value)}
          style={styles.dateSelect}
        >
          <option value="">Day</option>
          {days.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>

        <select
          value={dateParts.month}
          onChange={(e) => handleChange('month', e.target.value)}
          style={styles.dateSelect}
        >
          <option value="">Month</option>
          {months.map(m => (
            <option key={m.value} value={m.value}>{m.name}</option>
          ))}
        </select>

        <select
          value={dateParts.year}
          onChange={(e) => handleChange('year', e.target.value)}
          style={styles.dateSelect}
        >
          <option value="">Year</option>
          {years.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>
    );
  };


  return (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <button onClick={() => navigate(-1)} style={styles.backButton}>
          <ArrowBackIcon style={styles.backIcon} />
        </button>
        <h4 style={styles.heading}>Settings</h4>
      </div>

      {/* Profile Picture Section */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Change Profile Picture</h2>
        <div
          onClick={() => document.getElementById("fileInput").click()}
          style={styles.profileImageContainer}
        >
          {file ? (
            <>
              <img
                src={URL.createObjectURL(file)}
                style={styles.profileImage}
              />
            </>
          ) : (
            <div style={styles.profileImagePlaceholder}>Profile Image</div>
          )}
          <input id="fileInput" type="file" onChange={handleChange} hidden />
        </div>
        <button
          style={styles.button}
          onClick={() => handleImgUpload()}
          disabled={isImageUploading}
        >
          {isImageUploading ? "Uploading..." : "Upload New Image"}
        </button>
      </div>

      {/* Change Password Section */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Change Password</h2>
        <input
          type="email"
          placeholder="Email or phone"
          value={inputs.email}
          onChange={(e) => setInputs({ ...inputs, email: e.target.value })}
          style={styles.input}
        />
        <div style={styles.passwordInput}>
          <input
            type={hidePin ? "password" : "text"}
            placeholder="Current Password"
            value={inputs.oldPassword}
            onChange={(e) =>
              setInputs({ ...inputs, oldPassword: e.target.value })
            }
            style={styles.input}
          />
          <span
            style={styles.toggleVisibility}
            onClick={() => togglePasswordVisibility("old")}
          >
            {hidePin ? "👁️" : "👁️‍🗨️"}
          </span>
        </div>
        <div style={styles.passwordInput}>
          <input
            type={hideNewPin ? "password" : "text"}
            placeholder="New Password"
            value={inputs.newPassword}
            onChange={(e) =>
              setInputs({ ...inputs, newPassword: e.target.value })
            }
            style={styles.input}
          />
          <span
            style={styles.toggleVisibility}
            onClick={() => togglePasswordVisibility("new")}
          >
            {hideNewPin ? "👁️" : "👁️‍🗨️"}
          </span>
        </div>
        <div style={styles.passwordInput}>
          <input
            type={hideConfirmNewPin ? "password" : "text"}
            placeholder="Confirm New Password"
            value={inputs.confirmNewPassword}
            onChange={(e) =>
              setInputs({ ...inputs, confirmNewPassword: e.target.value })
            }
            style={styles.input}
          />
          <span
            style={styles.toggleVisibility}
            onClick={() => togglePasswordVisibility("confirm")}
          >
            {hideConfirmNewPin ? "👁️" : "👁️‍🗨️"}
          </span>
        </div>
        <button
          style={styles.button}
          onClick={handlePasswordChange}
          disabled={isLoadingPassword}
        >
          {isLoadingPassword ? "Saving..." : "Save New Password"}
        </button>
      </div>

      {/* Preferred Communication Section */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Preferred Communication</h2>
        <div style={styles.checkboxContainer}>
          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={isMailSelected}
              onChange={() => setIsMailSelected(!isMailSelected)}
            />
            Email
          </label>
          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={isPhoneSelected}
              onChange={() => setIsPhoneSelected(!isPhoneSelected)}
            />
            Phone
          </label>
        </div>
        <button
          style={styles.button}
          onClick={handleCommunicationUpdate}
          disabled={isLoadingCommunication}
        >
          {isLoadingCommunication ? "Updating..." : "Update Preferences"}
        </button>
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Personal Details</h2>

        {/* Date of Birth Field */}
        {/* <div style={styles.inputContainer}>
          <label style={styles.label}>Date of Birth</label>
          <input
            type="date"
            value={nok.dob.slice(0, 10) || ''}
            onChange={(e) => setNok({ ...nok, dob: e.target.value })}
            style={styles.input}
          />
        </div> */}

        {/* Date of Birth Field */}
        <div style={styles.inputContainer}>
          <label style={styles.label}>Date of Birth</label>
          <WhatsAppStyleDatePicker
            value={nok.dob || ''}
            onChange={(date) => setNok({ ...nok, dob: date })}
          />
        </div>

      </div>

      {/* Next of Kin and Marital Status Section */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Member Address, Next of Kin & Marital Status</h2>
        <input
          type="text"
          placeholder="Address"
          value={nok.address}
          onChange={(e) => setNok({ ...nok, address: e.target.value })}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Next of Kin Name"
          value={nok.name}
          onChange={(e) => setNok({ ...nok, name: e.target.value })}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Next of Kin Phone"
          value={nok.phone}
          onChange={(e) => setNok({ ...nok, phone: e.target.value })}
          style={styles.input}
        />
        <select
          value={nok.relationship}
          onChange={(e) => setNok({ ...nok, relationship: e.target.value })}
          style={styles.input}
        >
          <option value="">Relationship</option>
          <option value="Relative">Relative</option>
          <option value="Spouse">Spouse</option>
          <option value="Friend">Friend</option>
        </select>
        <select
          value={nok.marital}
          onChange={(e) => setNok({ ...nok, marital: e.target.value })}
          style={styles.input}
        >
          <option value="">Marital Status</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Engaged">Engaged</option>
          <option value="Widowed">Widowed</option>
        </select>
        {nok.marital === "Married" && (
          <>
            <input
              type="text"
              placeholder="Spouse Name"
              value={nok.spouseName}
              onChange={(e) => setNok({ ...nok, spouseName: e.target.value })}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="Spouse Phone"
              value={nok.spousePhone}
              onChange={(e) => setNok({ ...nok, spousePhone: e.target.value })}
              style={styles.input}
            />
          </>
        )}
        <button
          style={styles.button}
          onClick={handleDetailsUpdate}
          disabled={isLoadingDetails}
        >
          {isLoadingDetails ? "Updating..." : "Update Details"}
        </button>
      </div>
    </div>
  );
};

// Styles
const styles = {
  container: {
    padding: "20px",
    maxWidth: "500px",
    margin: "0 auto",
    marginBottom: "60px",
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '800px',
    marginBottom: '15px',
    position: 'relative'
  },
  backButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    marginRight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    ':hover': {
      backgroundColor: '#f0f2f5'
    }
  },
  backIcon: {
    color: '#1a6363',
    fontSize: '28px'
  },
  heading: {
    flex: 1,
    textAlign: 'center',
    fontSize: '24px',
    color: '#1a6363',
    fontWeight: '600',
    margin: 0,
    paddingRight: '52px'
  },
  section: {
    marginBottom: "40px",
  },
  sectionTitle: {
    fontSize: "18px",
    color: "#1a6363",
    marginBottom: "10px",
    // textAlign: "center",
  },
  profileImageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
  },
  profileImage: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  profileImagePlaceholder: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    backgroundColor: "#f0f0f0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#666",
  },
  fileInput: {
    display: "none",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  passwordInput: {
    position: "relative",
    width: "100%",
  },
  toggleVisibility: {
    position: "absolute",
    right: "10px",
    top: "10px",
    cursor: "pointer",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  button: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#1a6363",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  datePickerContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
  },
  dateSelect: {
    flex: 1,
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
};

export default Settings;